import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Select from "react-select";
import { editPlan } from "../actions/currency";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
// import { useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Form from "react-bootstrap/Form";

const initialFormValue = {
  name: "",
  fee: "",
  validity: "",
  duration: "",
  flashLoanAmount: "",
  flashLoanLimit: "",
  highlights: [],
  minProfitPerStatus: ""
};

function EditSubscription() {
  const [count, setCount] = useState(1);

  const [formvalue, setFormvalue] = useState(initialFormValue);
  const [errors, setErrors] = useState({});
  // const navigate = useNavigate();
  const history = useHistory();
  const location = useLocation();

  const [checkStatus, setCheckedStatus] = useState()
  console.log("🚀 ~ EditSubscription ~ checkStatus:", checkStatus)


  useEffect(() => {
    setFormvalue(JSON.parse(location.state.datas));
    console.log(formvalue?.minProfitPerStatus, "formvalue?.minProfitPerStatus")
    setCheckedStatus(JSON.parse(location.state.datas).minProfitPerStatus)
  }, []);

  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      console.log("🚀 ~ handleChange ~  name, value:", name, value)
      let Formvalue = { ...formvalue, [name]: value };
      setFormvalue(Formvalue);
      setErrors(validation(Formvalue));
    } catch (err) {
      console.log(err, "handleChange");
    }
  };


  const validation = (value) => {
    try {

      console.log(value, "VALUE")

      let error = { ...errors };
      if (isEmpty(value.name)) {
        error["name"] = "Name is required";
      } else {
        error["name"] = "";
      }
      if (isEmpty(value.fee)) {
        error["fee"] = "Fee is required";
      } else {
        error["fee"] = "";
      }

      if (ObjectIsempty(value.validity)) {
        error["validity"] = "Validity is required";
      } else {
        error["validity"] = "";
      }
      if (isEmpty(value.duration)) {
        error["duration"] = "Duration is required";
      } else {
        error["duration"] = "";
      }

      if (isEmpty(value.highlights)) {
        error["highlights"] = "Highlights is required";
      } else {
        error["highlights"] = "";
      }
      if (isEmpty(value.flashLoanAmount)) {
        error["flashLoanAmount"] = "Field is required";
      } else {
        error["flashLoanAmount"] = "";
      }
      if (isEmpty(value.referralPercentage)) {
        error["referralPercentage"] = "Referral Percentage is required";
      } else {
        error["referralPercentage"] = "";
      }
      if (isEmpty(value.tradesPerDay)) {
        error["tradesPerDay"] = "Trades Per Day is required";
      } else {
        error["tradesPerDay"] = "";
      }
      if (isEmpty(value.minProfitPercentage.toString())) {
        error["minProfitPercentage"] = "Min Profit Percentage is required";
      } else {
        error["minProfitPercentage"] = "";
      }
      if (isEmpty(value.maxProfitPercentage)) {
        error["maxProfitPercentage"] = "Max Profit Percentage is required";
      } else {
        error["maxProfitPercentage"] = "";
      }
      if (isEmpty(value.adminCommissionPer)) {
        error["adminCommissionPer"] = "Admin Profit Commission is required";
      } else {
        error["adminCommissionPer"] = "";
      }
      if (isEmpty(value.refferCommissionPer)) {
        error["refferCommissionPer"] = "Referral Profit Commission is required";
      } else {
        error["refferCommissionPer"] = "";
      }


      return error;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };

  const handleSubmit = async () => {
    try {
      let oj = {
        _id: formvalue._id,
        name: formvalue.name,
        fee: formvalue.fee,
        validity: formvalue.validity,
        duration: formvalue.duration,
        highlights: formvalue.highlights,
        referralPercentage: formvalue.referralPercentage,
        flashLoanAmount: formvalue.flashLoanAmount,
        minProfitPercentage: formvalue.minProfitPer,
        maxProfitPercentage: formvalue.maxProfitPer,
        adminCommissionPer: formvalue.adminCommissionPer,
        refferCommissionPer: formvalue.refferCommissionPer,
        tradesPerDay: formvalue.tradesPerDay,
        minProfitPerStatus: checkStatus
      };
      let isValidate = validation(oj);
      setErrors(isValidate);
      if (!ObjectIsempty(isValidate)) {
        return true;
      }
      let { status, message, result } = await editPlan(oj);
      if (status == "success") {
        toast.success("Plan Updated Successfully");
        history.push("/subscription");
      } else {
        toast.error("Plan Updated Failed");
        history.push("/subscription");
      }
    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };

  const handleHighlights = async (e, index) => {
    try {
      let arr = formvalue.highlights;
      arr[index] = e.target.value;
      let Formvalue = { ...formvalue, ["highlights"]: arr };
      setFormvalue(Formvalue);
      setErrors(validation(Formvalue));
      console.log(Formvalue, index, "EEEEEEE");
    } catch (err) {
      console.log(err, "handleHighlights");
    }
  };

  const options = [
    { value: "Hours", label: "hours" },
    { value: "Days", label: "days" },
    { value: "Weeks", label: "weeks" },
    { value: "Months", label: "months" },
    { value: "Years", label: "years" },
  ];
  const [selectedOption1, setSelectedOption1] = useState();
  const handleChange1 = (e) => {
    console.log(e, "selectedOptionselectedOption");
    let Formvalue = { ...formvalue, ["validity"]: e.value };
    setFormvalue(Formvalue);
    setSelectedOption1(e.value);
  };

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => {
      return {
        ...styles,
        backgroundColor: isHovered
          ? "#00ddeb"
          : isSelected
            ? "#00ddeb"
            : isFocused
              ? "#00ddeb"
              : "#000",
        cursor: "pointer",
        color: isHovered
          ? "#000"
          : isSelected
            ? "#000"
            : isFocused
              ? "#000"
              : "#fff",
        fontSize: "13px",
        zIndex: 1,
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "43px",
      padding: "0px 10px",

      backgroundColor: "transparent",
      color: "red",
      border: "1px solid #2c2c2c",
      borderRadius: "5px",
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "transparent",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "red",
      padding: "0px",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#ffffff",
    }),
    menuList: (base) => ({
      ...base,

      padding: 0,
      width: "100%",

      borderRadius: 5,
      background: "transparent",
    }),

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#fff",
      };
    },
  };

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>
          <Col xl={10} lg={12} className="pe-3">
            <Header title={"Edit Subscription"} />
            <div className="common_page_scroller mt-4 mt-sm-5 pe-2">
              <Row className="profile_holder">
                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Plan name</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="text"
                        placeholder="Plan name"
                        name="name"
                        onChange={handleChange}
                        value={formvalue.name}
                        disabled
                        className="rp_singleInput flex-grow-1"
                      />
                      <span className="text-danger">{errors?.name}</span>
                    </div>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Price</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Price"
                        name="fee"
                        min={1}
                        onChange={handleChange}
                        value={formvalue.fee}
                        disabled
                        className="rp_singleInput flex-grow-1"
                      />
                      <span className="text-danger">{errors?.fee}</span>
                    </div>
                  </div>
                </Col>


                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Trades Per Day</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Trades Per Day"
                        name="tradesPerDay"
                        min={1}
                        onChange={handleChange}
                        value={formvalue.tradesPerDay}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors?.tradesPerDay}
                    </span>
                  </div>
                </Col>


                <Col lg={7} md={8} sm={10} className="mb-4">
                  <Form.Check
                    type="switch"
                    className="remove_toggleBtn"
                    checked={checkStatus}
                    onClick={(e) => setCheckedStatus(e.target.checked)}
                  />
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Min Profit Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Min Profit Percentage"
                        name="minProfitPer"

                        onChange={handleChange}
                        value={formvalue.minProfitPer}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors?.minProfitPer}
                    </span>
                  </div>
                </Col>


                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Max Profit Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Max Profit Percentage"
                        name="maxProfitPer"

                        onChange={handleChange}
                        value={formvalue.maxProfitPer}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors?.maxProfitPer}
                    </span>
                  </div>
                </Col>


                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Referral Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Referral Percentage"
                        name="referralPercentage"
                        min={1}
                        onChange={handleChange}
                        disabled
                        value={formvalue.referralPercentage}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors?.referralPercentage}
                    </span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Admin Fee Profit Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Admin Profit Commission"
                        name="adminCommissionPer"
                        min={1}
                        onChange={handleChange}
                        value={formvalue.adminCommissionPer}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors?.adminCommissionPer}
                    </span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Referral Fee Profit Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Referral Profit Commission"
                        name="refferCommissionPer"
                        min={1}
                        onChange={handleChange}
                        value={formvalue.refferCommissionPer}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors?.refferCommissionPer}
                    </span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Flash Loan Limit</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Flash Loan Limit"
                        name="flashLoanAmount"
                        min={1}
                        onChange={handleChange}
                        value={formvalue.flashLoanAmount}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">{errors?.flashLoanAmount}</span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Validity</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">

                      {/* <Select
                      onChange={(e) => handleChange1(e)}
                      options={options}
                      name="validity"
                      defaultValue="theme1"
                      styles={stylesgraybg}
                      isSearchable={false}
                      classNamePrefix="customselect"
                      value={
                        formvalue.validity &&
                        options?.find((val) => val?.value == formvalue.validity)
                      }
                    /> */}
                      <input
                        type="string"
                        placeholder="Validity"
                        name="validity"
                        min={1}
                        onChange={handleChange}
                        value={formvalue.validity}
                        className="rp_singleInput flex-grow-1"
                        disabled
                      />
                      <span className="text-danger">{errors?.validity}</span>
                    </div>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Duration</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        name="duration"
                        min={1}
                        placeholder="Duration"
                        onChange={handleChange}
                        value={formvalue.duration}
                        className="rp_singleInput flex-grow-1"
                        disabled
                      />
                      <span className="text-danger">{errors?.duration}</span>
                    </div>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Highlights</p>
                    {[...Array(count)].map((item, index) => (
                      <div className="mb-3">
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            name="highlights"
                            onChange={(e) => handleHighlights(e, index)}
                            placeholder="Highlights"
                            className="rp_singleInput flex-grow-1"
                            value={formvalue?.highlights[index]}
                          />
                        </div>
                        <div className="d-flex gap-3 justify-content-end mt-3">
                          <button
                            className="subs_add_btn rounded-2"
                            onClick={() => setCount(count + 1)}>
                            <i class="fa-solid fa-plus" />
                          </button>
                          {count != 1 && (
                            <button
                              className="subs_dlt_btn rounded-2"
                              onClick={() => setCount(count - 1)}>
                              <i class="fa-solid fa-trash" />
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>

              <div className="d-flex gap-3 mb-5">
                <button className="secondary_btn">Cancel</button>
                <button
                  className="orange_primary_btn"
                  onClick={() => {
                    handleSubmit();
                  }}>
                  Save
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default EditSubscription;
